module.exports = require("./gu.d.ts");